import { gridFilterModelSelector, 
         GridHeaderFilterCellProps, 
         useGridApiContext, 
         useGridSelector 
       }                                      from "@mui/x-data-grid-pro";
import { Select, 
         SelectChangeEvent,
         MenuItem, 
         Checkbox, 
         ListItemText,
         FormControl,
         InputLabel,
         IconButton,
         Box
       }                                      from "@mui/material";
import { useCallback,
         useMemo
       }                                      from "react";
import CancelIcon                             from '@mui/icons-material/Cancel';

interface HomeProfileFilterComponentProps extends GridHeaderFilterCellProps {
  options: {
    id : string, 
    tag : string,
    name : string
  }[];
}

export const HomeProfileFilterComponent = (props : HomeProfileFilterComponentProps) => {

  const { colDef } = props;
  const apiRef = useGridApiContext();

  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback((event: SelectChangeEvent<string[]>) => {
      if (!event.target.value || event.target.value.length === 0) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'isAnyIn' }),
        value: event.target.value,
        id : colDef.field,
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );

  const handleClear = useCallback(() => {
    if (currentFieldFilters[0]) {
      apiRef.current.deleteFilterItem(currentFieldFilters[0]);
    }
  }, [apiRef, currentFieldFilters]);

  const value = currentFieldFilters[0]?.value ?? [];
  const label = 'Is Any Of'

  return (
    <Box sx={{ width: '100%', height: '38px', display: 'flex', alignItems: 'center', gap: 1, color: 'inherit' }}>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="select-is-admin-label" shrink>
          {label}
        </InputLabel>
        <Select
          multiple
          labelId="select-is-admin-label"
          id="select-is-admin"
          value={value}
          onChange={handleChange}
          label={label}
          notched
          renderValue={(selected) => selected.join(', ')}
          sx={{
            '& .MuiSelect-select' : {
              minHeight: 'unset',
              backgroundColor: 'inherit',
            }
          }}
        >
          {props.options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={value.indexOf(option.id) > -1} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {value.length > 0 && (
        <IconButton 
          size="small" 
          onClick={handleClear}
          sx={{ 
            p: 0.5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  )
}

interface ApplianceCategoryFilterComponentProps extends GridHeaderFilterCellProps {
  options: {id : string, name : string}[];
}

export const ApplianceCategoryFilterComponent = (props : ApplianceCategoryFilterComponentProps) => {

  const { colDef } = props;
  const apiRef = useGridApiContext();

  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback((event: SelectChangeEvent<string[]>) => {
      if (!event.target.value || event.target.value.length === 0) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'isAnyIn' }),
        value: event.target.value,
        id : colDef.field,
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );

  const handleClear = useCallback(() => {
    if (currentFieldFilters[0]) {
      apiRef.current.deleteFilterItem(currentFieldFilters[0]);
    }
  }, [apiRef, currentFieldFilters]);

  const value = currentFieldFilters[0]?.value ?? [];
  const label = 'Is Any Of'

  return (
    <Box sx={{ width: '100%', height: '38px', display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="select-is-admin-label" shrink>
          {label}
        </InputLabel>
        <Select
          multiple
          labelId="select-is-admin-label"
          id="select-is-admin"
          value={value}
          onChange={handleChange}
          label={label}
          notched
          renderValue={(selected) => selected.join(', ')}
          sx={{
            '& .MuiSelect-select' : {
              minHeight: 'unset',
              backgroundColor: 'inherit',
            }
          }}
        >
          {props.options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={value.indexOf(option.id) > -1} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {value.length > 0 && (
        <IconButton 
          size="small" 
          onClick={handleClear}
          sx={{ 
            p: 0.5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  )
}


interface MultiChoiceFilterComponentProps extends GridHeaderFilterCellProps {
  options: string[];
}

export const MultiChoiceFilterComponent = (props : MultiChoiceFilterComponentProps) => {

  const { colDef } = props;
  const apiRef = useGridApiContext();

  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback((event: SelectChangeEvent<string[]>) => {
      if (!event.target.value || event.target.value.length === 0) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'isAnyIn' }),
        value: event.target.value,
        id : colDef.field,
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );

  const handleClear = useCallback(() => {
    if (currentFieldFilters[0]) {
      apiRef.current.deleteFilterItem(currentFieldFilters[0]);
    }
  }, [apiRef, currentFieldFilters]);

  const value = currentFieldFilters[0]?.value ?? [];
  const label = 'Is Any Of'

  return (
    <Box sx={{ width: '100%', height: '38px', display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="select-is-admin-label" shrink>
          {label}
        </InputLabel>
        <Select
          multiple
          labelId="select-is-admin-label"
          id="select-is-admin"
          value={value}
          onChange={handleChange}
          label={label}
          notched
          renderValue={(selected) => selected.join(', ')}
          sx={{
            '& .MuiSelect-select' : {
              minHeight: 'unset',
              backgroundColor: 'inherit',
            }
          }}
        >
          {props.options.map((type) => (
            <MenuItem key={type} value={type}>
              <Checkbox checked={value.indexOf(type) > -1} />
              <ListItemText primary={type} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {value.length > 0 && (
        <IconButton 
          size="small" 
          onClick={handleClear}
          sx={{ 
            p: 0.5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  )
}
export interface SingleChoiceFilterComponentProps extends GridHeaderFilterCellProps {
  options: string[];
}

export const SingleChoiceFilterComponent = (props : SingleChoiceFilterComponentProps) => {
  
  const { colDef } = props;
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      if (!event.target.value) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'isAnyIn' }),
        value: event.target.value,
        id : colDef.field
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );
  
  const handleClear = useCallback(() => {
    if (currentFieldFilters[0]) {
      apiRef.current.deleteFilterItem(currentFieldFilters[0]);
    }
  }, [apiRef, currentFieldFilters]);

  const value = currentFieldFilters[0]?.value ?? '';
  const label = 'Is Any Of'

  return (
    <Box sx={{ width: '100%', height: '38px', display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="select-is-admin-label" shrink>
          {label}
        </InputLabel>
        <Select
          labelId="select-is-admin-label"
          id="select-is-admin"
          value={value}
          onChange={handleChange}
          label={label}
          notched
          sx={{
            '& .MuiSelect-select' : {
              minHeight: 'unset',
              backgroundColor: 'inherit',
            }
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {props.options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
            ))}
        </Select>
      </FormControl>
      {value.length > 0 && (
        <IconButton 
          size="small" 
          onClick={handleClear}
          sx={{ 
            p: 0.5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  );
}

export const BooleanFilterComponent = (props : GridHeaderFilterCellProps) => {
  const { colDef } = props;
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      if (!event.target.value) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'is' }),
        value: event.target.value,
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );

  const value = currentFieldFilters[0]?.value ?? '';
  const label = 'Is';

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <InputLabel id="select-is-admin-label" shrink>
        {label}
      </InputLabel>
      <Select
        labelId="select-is-admin-label"
        id="select-is-admin"
        value={value}
        onChange={handleChange}
        label={label}
        inputProps={{ sx: { fontSize: 14 } }}
        notched
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </Select>
    </FormControl>
  );
}

export interface BooleanObjectFilterComponentProps extends GridHeaderFilterCellProps {
  options: { type: string, value : string, label: string }[];
}

export const BooleanObjectFilterComponent = (props : BooleanObjectFilterComponentProps) => {

  const { colDef } = props;
  const apiRef = useGridApiContext();

  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const currentFieldFilters = useMemo(
    () => filterModel.items?.filter(({ field }) => field === colDef.field),
    [colDef.field, filterModel.items],
  );

  const handleChange = useCallback((event: SelectChangeEvent<string[]>) => {
      if (!event.target.value || event.target.value.length === 0) {
        if (currentFieldFilters[0]) {
          apiRef.current.deleteFilterItem(currentFieldFilters[0]);
        }
        return;
      }
      apiRef.current.upsertFilterItem({
        ...(currentFieldFilters[0] || { field: colDef.field, operator: 'isAnyIn' }),
        value: event.target.value,
        id : colDef.field
      });
    },
    [apiRef, colDef.field, currentFieldFilters],
  );

  const handleClear = useCallback(() => {
    if (currentFieldFilters[0]) {
      apiRef.current.deleteFilterItem(currentFieldFilters[0]);
    }
  }, [apiRef, currentFieldFilters]);

  const value = currentFieldFilters[0]?.value ?? [];
  const label = 'Is Any Of'

  return (
    <Box sx={{ width: '100%', height: '38px', display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="select-is-admin-label" shrink>
          {label}
        </InputLabel>
        <Select
          multiple
          labelId="select-is-admin-label"
          id="select-is-admin"
          value={value}
          onChange={handleChange}
          label={label}
          notched
          renderValue={(selected) => selected.map((sel : string) => props.options.find((option) => `${option.type}|${option.value}` === sel)?.label).join(', ')}
          sx={{
            '& .MuiSelect-select' : {
              minHeight: 'unset',
              backgroundColor: 'inherit',
            }
          }}
        >
          {props.options.map((option) => (
            <MenuItem key={option.label} value={`${option.type}|${option.value}`}>
              <Checkbox checked={value.indexOf(`${option.type}|${option.value}`) > -1} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {value.length > 0 && (
        <IconButton 
          size="small" 
          onClick={handleClear}
          sx={{ 
            p: 0.5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  )
}
